import Locator from 'mrg-smokescreen/Locator';

/*global define */
/**
* @module OK/Smokescreen
*
* Методы для получения элементов dom-дерева в обфусцированном HTML-е (обход блокировщиков рекламы)
*/

'use strict';

var locator = null;

function getLocator(propertiesToRandomize) {
    if (locator) {
        return locator;
    }

    locator = new Locator({
        enable: true,
        randomize: propertiesToRandomize ? propertiesToRandomize : false,
        match: ['.*']
    });

    return locator;
}

function getById(id) {
    var el = document.getElementById(id);

    if (!el && locator) {
        el = document.getElementById(locator.transform(id));
    }
    return el ? el : null;
}

export default { getLocator, getById };

export { getLocator, getById };
